"use strict";

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMulticallAtChain = exports.validateCall = exports.useReadOnlyProvider = exports.multicall = exports.multicall2 = void 0;
var core_1 = require("@usedapp/core");
var react_1 = require("react");
var providers_1 = require("@ethersproject/providers");
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var ABI = ["function aggregate(tuple(address target, bytes callData)[] calls) view returns (uint256 blockNumber, bytes[] returnData)"];
var ABI2 = ["function tryAggregate(bool requireSuccess, tuple(address target, bytes callData)[] calls) public view returns (tuple(bool success, bytes returnData)[])"];
function multicall2(_x, _x2, _x3, _x4) {
  return _multicall.apply(this, arguments);
}
function _multicall() {
  _multicall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(provider, address, blockNumber, requests) {
    var contract, results, state;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(requests.length === 0)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", []);
        case 2:
          contract = new ethers_1.Contract(address, ABI2, provider);
          _context3.next = 5;
          return contract.tryAggregate(false, requests.map(function (_ref7) {
            var address = _ref7.address,
              data = _ref7.data;
            return [address, data];
          }), {
            blockTag: blockNumber
          });
        case 5:
          results = _context3.sent;
          state = requests.map(function (r, i) {
            var address = r.address,
              data = r.data;
            var _results$i = _slicedToArray(results[i], 2),
              success = _results$i[0],
              value = _results$i[1];
            var result = _objectSpread(_objectSpread({}, r), {}, {
              address: address,
              data: data,
              value: value,
              success: success
            });
            return result;
          });
          return _context3.abrupt("return", state);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _multicall.apply(this, arguments);
}
exports.multicall2 = multicall2;
function multicall(_x5, _x6, _x7, _x8) {
  return _multicall2.apply(this, arguments);
}
function _multicall2() {
  _multicall2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(provider, address, blockNumber, requests) {
    var contract, _yield$contract$aggre, _yield$contract$aggre2, results, state;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(requests.length === 0)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", []);
        case 2:
          contract = new ethers_1.Contract(address, ABI, provider);
          _context4.next = 5;
          return contract.aggregate(requests.map(function (_ref8) {
            var address = _ref8.address,
              data = _ref8.data;
            return [address, data];
          }), {
            blockTag: blockNumber
          });
        case 5:
          _yield$contract$aggre = _context4.sent;
          _yield$contract$aggre2 = _slicedToArray(_yield$contract$aggre, 2);
          results = _yield$contract$aggre2[1];
          state = requests.map(function (r, i) {
            var address = r.address,
              data = r.data;
            var result = _objectSpread(_objectSpread({}, r), {}, {
              address: address,
              data: data,
              value: results[i],
              success: true
            });
            return result;
          });
          return _context4.abrupt("return", state);
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _multicall2.apply(this, arguments);
}
exports.multicall = multicall;
var useReadOnlyProvider = function useReadOnlyProvider(chainId) {
  var _ref = (0, core_1.useConfig)(),
    readOnlyUrls = _ref.readOnlyUrls,
    pollingInterval = _ref.pollingInterval;
  var provider = (0, react_1.useMemo)(function () {
    if (!readOnlyUrls || !readOnlyUrls[chainId]) {
      return;
    }
    var factory = readOnlyUrls[chainId];
    if (factory instanceof providers_1.BaseProvider) {
      return factory;
    }
    if (typeof factory === "function") {
      return factory();
    }
    var provider = new providers_1.JsonRpcProvider(factory);
    provider.pollingInterval = pollingInterval;
    return provider;
  }, [readOnlyUrls, pollingInterval, chainId]);
  return provider;
};
exports.useReadOnlyProvider = useReadOnlyProvider;
/**
 * @internal Intended for internal use - use it on your own risk
 */
function validateCall(call) {
  var contract = call.contract,
    method = call.method,
    args = call.args;
  if (!contract.address || !method) {
    throw new Error("Missing contract address or method name");
  }
  try {
    contract.interface.encodeFunctionData(method, args);
    return call;
  } catch (err) {
    throw new Error("Invalid contract call for method=\"".concat(method, "\" on contract=\"").concat(contract.address, "\": ").concat(err.message));
  }
}
exports.validateCall = validateCall;
/* @internal Intended for internal use - use it on your own risk
 * @returns
 * One of these:
 * - a RawCall, if encoding is successful.
 * - Falsy, if there is no call to encode.
 * - an Error, if encoding fails (e.g. because of mismatched arguments).
 */
function encodeCallData(call, chainId) {
  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  if (!call) {
    return undefined;
  }
  try {
    validateCall(call);
  } catch (e) {
    return e;
  }
  var contract = call.contract,
    method = call.method,
    args = call.args;
  var isStatic = (_a = queryParams.isStatic) !== null && _a !== void 0 ? _a : queryParams.refresh === "never";
  var refreshPerBlocks = typeof queryParams.refresh === "number" ? queryParams.refresh : undefined;
  return {
    address: contract.address,
    data: contract.interface.encodeFunctionData(method, args),
    chainId: chainId,
    isStatic: isStatic,
    refreshPerBlocks: refreshPerBlocks
  };
}
/**
 * perform multicall requests to a specific chain using readonly rpcs from usedapp
 */
var useMulticallAtChain = function useMulticallAtChain(chainId) {
  var provider = (0, exports.useReadOnlyProvider)(chainId);
  var _ref2 = (0, core_1.useConfig)(),
    multicallVersion = _ref2.multicallVersion,
    multicallAddresses = _ref2.multicallAddresses;
  var pendingCalls = (0, react_1.useRef)({
    calls: []
  });
  var _resolve = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(calls, blockNumber) {
      var multiAddr, method, address, rawcalls, currentBlock, results;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            multiAddr = multicallAddresses && Object.entries(multicallAddresses).find(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 1),
                k = _ref5[0];
              return k === String(chainId);
            });
            if (!(provider && multiAddr)) {
              _context.next = 13;
              break;
            }
            method = multicallVersion === 1 ? multicall : multicall2;
            address = multiAddr[1];
            rawcalls = calls.map(function (call) {
              return encodeCallData(call, chainId);
            }).filter(Boolean);
            _context.next = 7;
            return provider.getBlockNumber();
          case 7:
            currentBlock = _context.sent;
            _context.next = 10;
            return method(provider, address, blockNumber || currentBlock, rawcalls);
          case 10:
            results = _context.sent;
            results.forEach(function (r, i) {
              var call = calls[i];
              r.decoded = call.contract.interface.decodeFunctionResult(call.method, r.value);
            });
            return _context.abrupt("return", results);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x9, _x10) {
      return _ref3.apply(this, arguments);
    };
  }(), [multicallAddresses, provider, multicallVersion, chainId]);
  var callMulti = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(calls, blockNumber) {
      var p;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (provider) {
              _context2.next = 3;
              break;
            }
            p = new Promise(function (res) {
              pendingCalls.current.calls = pendingCalls.current.calls.concat(calls);
              pendingCalls.current.resolve = res;
              pendingCalls.current.blockNumber = blockNumber;
            });
            return _context2.abrupt("return", p);
          case 3:
            return _context2.abrupt("return", _resolve(calls, blockNumber));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }(), [provider]);
  /*
        this will handle the case if we got calls before we had a provider
    */
  (0, react_1.useEffect)(function () {
    if (provider && pendingCalls.current.calls.length > 0) {
      var calls = pendingCalls.current.calls;
      var resolve = pendingCalls.current.resolve;
      var bn = pendingCalls.current.blockNumber;
      pendingCalls.current = {
        calls: []
      };
      _resolve(calls, bn).then(resolve).catch(lodash_1.noop);
    }
  }, [provider]);
  return callMulti;
};
exports.useMulticallAtChain = useMulticallAtChain;